import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { ModalSetting } from './modal.model';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalSubject = new Subject<ModalSetting | null>();
  modalState$ = this.modalSubject.asObservable();

  constructor() { }

  showModal(modalSetting: ModalSetting) {
    this.modalSubject.next(modalSetting);
  }

  hideModal() {
    this.modalSubject.next(null);
  }
}
